<template>
    <div class="ql-main-container">
        <div :id="'tstyle-' + _uid" @click="setQuillStatus">
            <component is="svg-select-all" v-show="false" :ref="'svg-all-' + _uid"></component>
            <component is="paste-format" v-show="false" :ref="'paste-format-' + _uid"></component>
            <component is="image-link" v-show="false" :ref="'image-link-' + _uid"></component>
            <component is="image-size" v-show="false" :ref="'image-size-' + _uid"></component>
            <component v-for="c of extraButtons" :is="c.comp" :ref="c.name + '-' + _uid" v-show="false" :key="c.name"></component>
        </div>
    </div>
</template>

<script>
import ImageLink from '@/components/svg/ImageLink';
import ImageSize from '@/components/svg/ImageSize';
import PasteFormat from '@/components/svg/PasteFormat';
import SelectAll from '@/components/svg/SelectAll';
import '@/quill/quill.snow.css';
import { mapState } from 'vuex';
export default {
    name: 'text-area-style',
    props: ['text', 'size', 'tabId', 'pasteText', 'id', 'maxHeight', 'disabled', 'showPin', 'extras'],
    components: {
        'svg-select-all': SelectAll,
        'paste-format': PasteFormat,
        'image-link': ImageLink,
        'image-size': ImageSize,
    },
    data () {
        return {
            value: null,
            init: false,
            defSize: '14px',
            counter: 0,
            interval: null,
            ready: false,
            pasteFormat: false,
            skipUpdate: false,
            quill: null,
            selectedImage: null
        }
    },
    computed: {
        ...mapState({
            quillFocus: state => state.quill.quillFocus,
            quillStatus: state => state.quill.quillStatus,
        }),
          extraButtons () {
            return this.extras? this.extras: [];
        }
    },
    watch: {
        pasteText () {
            if (this.pasteText) {
                this.value = _.cloneDeep(this.pasteText);
                this.setText(this.value);
            }
        },
        counter () {
            if (this.counter>0) this.init = true;
            if (this.counter==0 && this.init) {
                this.emitUpdate(true)
            }
        },
        quillStatus () {
            if (!this.quillStatus) {
                this.emitUpdate(true);
            }
        }
    },
    async mounted (){
        let text = this.text;
        if (text) {
            text = this.convertOldLists(text);
        }
        this.value = _.cloneDeep(text);
        let self = this;
        setTimeout(() => {self.ready = true}, 100);
        if (this.size) this.defSize = this.size;

        let Size = Quill.import('attributors/style/size');
        Size.whitelist = ['12px', '14px', '16px', '18px'];
        Quill.register(Size, true);

        let Size2 = Quill.import('attributors/style/size');
        Size2.whitelist = ['25px', '50px', '75px', '100px', '150px', '200px', '250px', '300px', '400px', '500px', '750px', '1000px'];
        Quill.register(Size2, true);



        const COLORS = [
            "#000000", "#e60000", "#ff9900", "#ffff00", "#008A00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#2F5496", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"
          ];

        let toolbarOptions = {
            container: [
              { 'size':  ['12px', '14px', '16px', '18px'] },
              'bold',
              'italic',
              'underline',
              'clean',
              'select-all',
              'paste-format',
              { 'list': 'ordered'}, { 'list': 'bullet' }, {'color': COLORS}, {'background': COLORS},
              { 'align': ['', 'center', 'right', 'justify'] },
              'link',
              'image',
              'video',
              'image-link',
              { 'size2':  ['25px', '50px', '75px', '100px', '150px', '200px', '250px', '300px', '400px', '500px', '750px', '1000px'] },
              //'emoji'
            ],
            //handlers: {'emoji': () => {}}
            handlers: {
                'select-all': () => { this.quill.setSelection(0, this.quill.getLength()) },
                'paste-format': () => { self.pasteFormat = !self.pasteFormat; },
                'image-link': () => {
                    const url = prompt('Enter the image URL:');
                    if (url) {
                        const range = this.quill.getSelection(true);
                        this.quill.insertEmbed(range.index, 'image', url);
                    }
                },
                'size2': (value) => {
                    // If we have a selected image, apply the size directly
                    if (this.selectedImage) {
                        this.selectedImage.style.width = value;
                        this.selectedImage.setAttribute('width', value);
                        this.emitUpdate(true);
                        return;
                    }
                    
                    // Fallback to the original logic
                    let selection = this.quill.getSelection();
                    if (!selection) return;
                    
                    // Apply width to the selected or closest image
                    this.applyImageWidth(selection, value);
                }
            }
        };
        if (this.extras) {
          for (let c of this.extras) {
             toolbarOptions.container.push(c.name)
             toolbarOptions.handlers[c.name] = () => {c.callback(self)};
          }
        }

        let quillId = '#tstyle-' + this._uid;
        this.quill = new Quill(quillId, {
            'modules': {
              'toolbar': toolbarOptions,
            },
            theme: 'snow',
            readOnly: self.disabled,
        });

        this.setText(this.value);


        this.quill.on('text-change', (delta, oldDelta, source) => {
            if (source == 'user') {
                if (!self.interval && self.ready) {
                    self.setInterval();
                }
                // Clean up any orphaned selections after text changes
                setTimeout(() => {
                    self.cleanupOrphanedSelections();
                }, 50);
            }
        });

        // Add selection change listener to clean up when cursor moves away from images
        this.quill.on('selection-change', (range, oldRange, source) => {
            if (range && range.length === 0) {
                // Cursor moved to a text position, check if we need to clear image selection
                let selection = this.quill.getSelection();
                if (selection) {
                    let [leaf] = this.quill.getLeaf(selection.index);
                    if (!leaf || !leaf.domNode || leaf.domNode.tagName !== 'IMG') {
                        // We're not on an image, clear image selection
                        setTimeout(() => {
                            if (this.selectedImage) {
                                this.setSelectedImage(null);
                            }
                        }, 10);
                    }
                }
            }
        });

        this.quill.root.addEventListener('blur', () => {
            this.emitUpdate(true)
        });

        // Add double-click listener for images
        this.quill.root.addEventListener('dblclick', (e) => {
            if (e.target.tagName === 'IMG') {
                // Select the image by finding its position in the editor
                let imgIndex = this.getImageIndex(e.target);
                this.quill.setSelection(imgIndex, 1);
                // Store reference to the selected image (this will clear previous ones)
                this.setSelectedImage(e.target);
                // Force cleanup after double click
                setTimeout(() => {
                    this.cleanupOrphanedSelections();
                }, 10);
            }
        });

        // Add click listener to track image selection
        this.quill.root.addEventListener('click', (e) => {
            if (e.target.tagName === 'IMG') {
                let imgIndex = this.getImageIndex(e.target);
                this.quill.setSelection(imgIndex, 1);
                this.setSelectedImage(e.target);
            } else {
                this.setSelectedImage(null);
            }
            // Force cleanup after any click
            setTimeout(() => {
                this.cleanupOrphanedSelections();
            }, 10);
        });

        this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
          if (!self.pasteFormat) {
              delta.ops = delta.ops.map(op => {
                return {
                  insert: op.insert
                }
              })
              setTimeout(() => {
                  self.emitUpdate(true);
              }, 10)
          }
          return delta
        })

        if (this.tabId) {
            let customButtons = $('#' + this.tabId + ' .ql-clean');
            if (customButtons && customButtons.length>0) {
                for (let customButton of customButtons) {
                    customButton.addEventListener('click', () => {
                        let text = this.quill.getText(0, this.quill.getLength());
                        this.quill.setText(text);
                        this.quill.formatText(0, this.quill.getLength() );
                        self.$emit("update:text", text);
                    });
                }
            }
        }

        await this.$nextTick();

        let qdiv = $('#tstyle-' + self._uid).parent()[0];
        if (this.maxHeight) {
            $('#tstyle-' + self._uid).height(this.maxHeight);
        }
        let toolbar = $(qdiv).find('.ql-toolbar')[0];

        let child = self.$refs['svg-all-' + self._uid];
        if (child) {
            let html = child.$el.innerHTML;
            let cleanAll = $(toolbar).find('.ql-select-all');
            if (cleanAll && cleanAll.length>0) {
                cleanAll.append(html)
                /*cleanAll[0].addEventListener('click', () => {
                    quill.setSelection(0, quill.getLength());
                });*/
            }
        }

        let child2 = self.$refs['paste-format-' + self._uid];
        if (child2) {
            let html2 = child2.$el.innerHTML;
            let pasteFormat = $(toolbar).find('.ql-paste-format');
            if (pasteFormat && pasteFormat.length>0) {
                pasteFormat.append(html2)
                /*pasteFormat[0].addEventListener('click', async () => {
                    self.pasteFormat = !self.pasteFormat;
                });*/
            }
        }

        if (this.extras) {
          for (let c of this.extras) {
            let child4 = self.$refs[c.name + '-' + self._uid];
            if (child4 && child4[0]) {
                let html4 = child4[0].$el.innerHTML;
                let button = $(toolbar).find('.ql-' + c.name);
                if (button && button.length>0) {
                    button.append(html4)
                    /*button[0].addEventListener('click', async () => {
                        c.callback(self)
                    });*/
                }
            }

          }
        }

        let imageLink = self.$refs['image-link-' + self._uid];
        if (imageLink) {
            let htmlImageLink = imageLink.$el.innerHTML;
            let imageLinkButton = $(toolbar).find('.ql-image-link');
            if (imageLinkButton && imageLinkButton.length>0) {
                imageLinkButton.append(htmlImageLink)
            }
        }

        let imageSize = self.$refs['image-size-' + self._uid];
        if (imageSize) {
            let htmlImageSize = imageSize.$el.innerHTML;
            let imageSizeButton = $(toolbar).find('.ql-size2');
            if (imageSizeButton && imageSizeButton.length>0) {
                imageSizeButton.append(htmlImageSize)
            }
        }

    },
    methods: {
        convertOldLists (html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const ulElements = tempDiv.querySelectorAll('ul');
            if (ulElements && ulElements.length>0) {
                ulElements.forEach(ul => {
                    const ol = document.createElement('ol');
                    ol.setAttribute('data-list', 'bullet');
                    Array.from(ul.children).forEach(li => {
                        const newLi = document.createElement('li');
                        newLi.setAttribute('data-list', 'bullet');
                        newLi.innerHTML = li.innerHTML;
                        ol.appendChild(newLi);
                    });
                    ul.replaceWith(ol);
                });
                return tempDiv.innerHTML;
            }
            return html;
        },
        getText () {
            let self = this;
            return $(self.$el).find('.ql-editor')[0].innerHTML;
        },
        setValue (value, skipUpdate) {
            this.skipUpdate = true;
            this.value = value;
            this.setText(value);
            this.setSelectedImage(null); // Clear image selection when content changes
        },
        setText (value) {
            //$(this.$el).find('.ql-editor')[0].innerHTML = value;
            this.quill.root.innerHTML = value;
        },
        setInterval: function() {
            let self = this;
            this.counter = 1500;
            this.interval = setInterval(() => {
                if (self.counter>0) {
                    self.counter += -500;
                } else {
                    clearInterval(self.interval)
                    self.interval = null;
                }
            }, 500);
        },
        setQuillStatus () {
            if (!this.quillFocus) {
                this.$store.commit('setQuillFocus', 'tstyle-' + this._uid);
            }
            this.$store.commit('setQuillStatus', true);
        },
        emitUpdate (change) {
            if (!this.skipUpdate) {
                this.$emit("update:text", this.getText());
                if (change) this.$emit("change");
            }
            this.skipUpdate = false;

        },
        applyImageWidth (selection, widthValue) {
            // First, try to find if there are images in the current selection
            if (selection.length > 0) {
                // Get content in the selection
                let delta = this.quill.getContents(selection.index, selection.length);
                let hasImages = false;
                
                // Check if the selection contains images
                delta.ops.forEach(op => {
                    if (op.insert && typeof op.insert === 'object' && op.insert.image) {
                        hasImages = true;
                    }
                });
                
                if (hasImages) {
                    // Find all images in the editor and apply width to those in the selection range
                    let allImages = this.quill.root.querySelectorAll('img');
                    allImages.forEach(img => {
                        // Get the image's position in the Quill editor
                        let imgIndex = this.getImageIndex(img);
                        if (imgIndex >= selection.index && imgIndex < selection.index + selection.length) {
                            img.style.width = widthValue;
                            img.setAttribute('width', widthValue);
                        }
                    });
                    this.emitUpdate(true);
                    return;
                }
            }
            
            // If no images in selection, try to find the closest image to the cursor
            let allImages = this.quill.root.querySelectorAll('img');
            let closestImage = null;
            let closestDistance = Infinity;
            
            allImages.forEach(img => {
                let imgIndex = this.getImageIndex(img);
                let distance = Math.abs(imgIndex - selection.index);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestImage = img;
                }
            });
            
            // Apply width to the closest image
            if (closestImage) {
                closestImage.style.width = widthValue;
                closestImage.setAttribute('width', widthValue);
                this.emitUpdate(true);
            }
        },
        
        setSelectedImage (imgElement) {
            // Remove selection from ALL images by removing the data attribute
            if (this.quill && this.quill.root) {
                let allImages = this.quill.root.querySelectorAll('img');
                allImages.forEach(img => {
                    img.removeAttribute('data-quill-selected');
                    // Force clean any inline styles that might be persisting
                    if (img.style.border || img.style.boxShadow) {
                        let currentStyle = img.getAttribute('style') || '';
                        // Remove border and box-shadow from style attribute
                        currentStyle = currentStyle
                            .replace(/border[^;]*;?/gi, '')
                            .replace(/box-shadow[^;]*;?/gi, '')
                            .replace(/;;+/g, ';')
                            .replace(/^;|;$/g, '');
                        
                        if (currentStyle.trim()) {
                            img.setAttribute('style', currentStyle);
                        } else {
                            img.removeAttribute('style');
                        }
                    }
                });
            }
            
            // Set new selected image
            this.selectedImage = imgElement;
            
            // Add selection using data attribute
            if (this.selectedImage) {
                this.selectedImage.setAttribute('data-quill-selected', 'true');
            }
        },
        
        cleanupOrphanedSelections () {
            // Remove any data-quill-selected attributes that might be lingering
            if (this.quill && this.quill.root) {
                let selectedImages = this.quill.root.querySelectorAll('img[data-quill-selected="true"]');
                selectedImages.forEach(img => {
                    if (img !== this.selectedImage) {
                        img.removeAttribute('data-quill-selected');
                    }
                });
            }
        },
        
        getImageIndex (imgElement) {
            // Find the index of an image element in the Quill editor
            let walker = document.createTreeWalker(
                this.quill.root,
                NodeFilter.SHOW_ALL,
                null,
                false
            );
            
            let index = 0;
            let node;
            
            while (node = walker.nextNode()) {
                if (node === imgElement) {
                    return index;
                }
                
                if (node.nodeType === Node.TEXT_NODE) {
                    index += node.textContent.length;
                } else if (node.tagName === 'IMG' || node.tagName === 'BR') {
                    index += 1;
                }
            }
            
            return index;
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
        this.setSelectedImage(null); // Clean up image selection
    },
}
</script>

<style>
img[data-quill-selected="true"] {
    border: 2px solid #007bff !important;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5) !important;
}

/* Ensure no conflicting styles */
.ql-editor img {
    border: none;
    box-shadow: none;
}
</style>

